var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 8.99874H17.0021",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99792 8.72464L7.9173 9.55299L9.76807 7.88629",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99916 20.0033H7.99833C5.23576 20.0033 2.99625 17.7638 2.99625 15.0012V6.9979C2.99625 4.23533 5.23576 1.99582 7.99833 1.99582H16.0017C17.3283 1.99582 18.6006 2.52282 19.5387 3.4609C20.4767 4.39897 21.0037 5.67127 21.0037 6.9979V9.99915",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99792 13.7267L7.9173 14.5551L9.76807 12.8884",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 13.9006V19.6033C14.0018 20.3766 15.5683 21.0037 17.5018 21.0037C19.4353 21.0037 21.0017 20.3766 21.0027 19.6033V13.9006",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0018 16.752C14.0018 17.5252 15.5693 18.1524 17.5028 18.1524C19.4363 18.1524 21.0037 17.5252 21.0037 16.752",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0018 13.9006C14.0018 14.6738 15.5693 15.301 17.5028 15.301C19.4363 15.301 21.0027 14.6738 21.0027 13.9006C21.0027 13.1264 19.4343 12.5002 17.5018 12.5002C15.5693 12.5002 14.0018 13.1274 14.0008 13.9006",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.f210e640627faf73e99c334c3c71077a.svg";
export { ForwardRef as ReactComponent };